import { Button, Link } from '@gyym/ui'
import { Menu, Search } from '@gyym/ui/icons'
import React from 'react'

import { useAuthUser } from '@/modules/Auth'

import { Logo } from '../Logo'
import { HeaderContainer, IconButton, LogoLink } from './styles'

export { HEADER_HEIGHT } from './styles'

export interface HeaderProps {
  isSticky?: boolean
  isTop?: boolean
  onMenuClick?: () => void
}

export const Header = ({ isSticky, isTop, onMenuClick }: HeaderProps) => {
  const { isLoggedIn } = useAuthUser()

  return (
    <HeaderContainer isSticky={isSticky} isTop={isTop}>
      {isSticky && (
        <LogoLink href="/" scroll>
          <Logo />
        </LogoLink>
      )}

      <div className="ml-auto flex items-center gap-6">
        {!isLoggedIn && (
          <Button variant="primary-ghost" size="sm" rounded asChild>
            <Link href="/signup">新規登録</Link>
          </Button>
        )}

        <Link href="/search" aria-label="検索メニューを開く">
          <IconButton as="span">
            <Search />
          </IconButton>
        </Link>

        <IconButton onClick={onMenuClick} aria-label="メニューを開く">
          <Menu />
        </IconButton>
      </div>
    </HeaderContainer>
  )
}
